import { render, staticRenderFns } from "./ClientCreate.vue?vue&type=template&id=91247bd2&"
import script from "./ClientCreate.vue?vue&type=script&lang=ts&"
export * from "./ClientCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports